import * as React from "react"
import { useContext, useEffect } from "react"
import { TOCContext } from "src/components/TableOfContents"

interface ShortHeadingProps {
    id?: string
    text?: string
    children: any
}

export function H2(props: ShortHeadingProps) {
    return <Heading
        level={2}
        id={props.id}
        text={getHeadingText(props)}
        children={props.children}
    />
}

export function H3(props: ShortHeadingProps) {
    return <Heading
        level={3}
        id={props.id}
        text={getHeadingText(props)}
        children={props.children}
    />
}

export function H4(props: ShortHeadingProps) {
    return <Heading
        level={4}
        id={props.id}
        text={getHeadingText(props)}
        children={props.children}
    />
}

export function H5(props: ShortHeadingProps) {
    return <Heading
        level={5}
        id={props.id}
        text={getHeadingText(props)}
        children={props.children}
    />
}

export function H6(props: ShortHeadingProps) {
    return <Heading
        level={6}
        id={props.id}
        text={getHeadingText(props)}
        children={props.children}
    />
}

function getHeadingText(props: ShortHeadingProps) {
    return props.text ?? props.children.toString?.() ?? "[Unable to render as text]"
}

function Heading(props: {
    level: 1 | 2 | 3 | 4 | 5 | 6
    id?: string
    text: string
    children: any
}) {
    const {
        level,
        text,
        children
    } = props

    const { push } = useContext(TOCContext)

    const id = props.id ?? text.replace(/ /g, "-")
        .replace(/[^a-zA-Z\-]/g, "")
        .toLowerCase()

    useEffect(() => {
        push({ id, text, level })
    }, [push])

    return React.createElement(`h${level}`, null, <a id={id}>{children}</a>)
}